import {TextSearchFilterComponent} from './text-search-filter/text-search-filter.component';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CacheDataService} from '../../api/services/cache-data.service';
import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, forwardRef, Input, NgZone, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {CdkVirtualScrollViewport} from '@angular/cdk/scrolling';
import {Title} from '../../api/models/title';
import {CleanLocation} from '../../api/models/clean-location';
import {Company} from '../../api/models/company';
import {Attribute_Category} from '../../api/models/attribute-_category';

@Component({
  selector: 'attribute-search',
  templateUrl: './text-search-filter/text-search-filter.component.html',
  styleUrls: ['./text-search-filter/text-search-filter.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AttributeSearchComponent),
      multi: true
    }
  ]
})
export class AttributeSearchComponent extends TextSearchFilterComponent<Attribute_Category> implements ControlValueAccessor, OnInit, AfterViewInit
{
  @ViewChild('scrollDiv') scrollDiv : ElementRef;
  @Input() fixedHeight?: number;
  @Input() showSelected: boolean = false;

  constructor(cacheDataService: CacheDataService, ngZone: NgZone) {
    super(cacheDataService, ngZone);
  }

  dataUpdated(): void {}

  protected getShowSelected(): boolean {
    return this.showSelected;
  }

  protected getHeightValue() : number | undefined {
    if (this.fixedHeight) {
      return this.fixedHeight;
    }
    return undefined;
  }

  ngOnInit() {
    this.callNgOnInit();
  }

  ngAfterViewInit() {
    this.callNgAfterViewInit();
  }

  protected getDivScroller(): ElementRef {
    return this.scrollDiv;
  }

  protected isSelected(target: Attribute_Category) : boolean {
    const exists = this._value && this._value.selectedValues && this._value.selectedValues.find(x => x.attributeType == target.attributeType && x.attributeCategory == target.attributeCategory);
    return !!exists;

  }

  protected getDisplay(target: Attribute_Category): string {
    return target.attributeType + ' - ' + target.attributeCategory;
  }

  protected newSearch() {
    this.reloading = true;
    this.cacheDataService.cacheDataSearchAttributes({
      pageNumber: 1,
      pageSize: 100,
      search: this.value?.searchTerms ?? []
    }).subscribe(result => {
      this.currentPage = 1;
      this.totalPages = result.totalPages;
      this.sourceValues = result.page;
      this.reloading = false;
    });
  }
  protected getNextBatch() {
    if (this.currentPage < this.totalPages) {
      this.loading = true;
      this.currentPage++;
      this.cacheDataService.cacheDataSearchAttributes({
        pageNumber: this.currentPage,
        pageSize: 100,
        search: this._value?.searchTerms ?? [],
      }).subscribe(result => {
        this.totalPages = result.totalPages;
        this.loading = false;
        this.sourceValues = [...this.sourceValues, ...result.page];
      });
    }
  }

  protected getSearchPlaceholder(): string {
    return 'Job Attribute Keyword...';
  }
}
